.Container {
  --gutter-x: var(--space-3xl);

  padding-left: calc(var(--gutter-x) * 0.5);
  padding-right: calc(var(--gutter-x) * 0.5);
  width: 100%;

  &:not(.fluid) {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (--sm) {
  .Container:not(.fluid) {
    max-width: var(--container-width-sm);
  }
}

@media (--md) {
  .Container:not(.fluid) {
    max-width: var(--container-width-md);
  }
}

@media (--lg) {
  .Container:not(.fluid) {
    max-width: var(--container-width-lg);
  }
}

@media (--xl) {
  .Container:not(.fluid) {
    max-width: var(--container-width-xl);
  }
}

@media (--xxl) {
  .Container:not(.fluid) {
    max-width: var(--container-width-2xl);
  }
}
